import React, { useEffect, useState } from "react";
import axios from "axios";
import { GoogleMap, LoadScript, Autocomplete } from "@react-google-maps/api";
import { GOOGLE_KEY } from "../../utils/common";
import { LocationSvg } from "../../images/Svgs";

const LocationSearch = ({
  eventData,
  setEventData,
  eventError,
  setEventError,
  editEvent,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (Object.keys(editEvent).length > 0) {
      setSearchQuery(editEvent?.event_location);
    }
  }, [editEvent]);

  useEffect(() => {
    if (selectedLocation?.lat) {
      fetchAddress();
    }
  }, [searchQuery, selectedLocation?.lat]);
  const fetchAddress = async () => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${selectedLocation?.lat},${selectedLocation?.lng}&key=${GOOGLE_KEY}`;
    try {
      const response = await axios.get(url);

      if (response.data.status === "OK") {
        const results = response.data.results;

        if (!results || results.length === 0) {
          console.error("No results found in the Geocoding API response.");
          return;
        }
        const primaryResult = results[0]; // Use the first result as the primary address
        const addressComponents = primaryResult?.address_components || [];
        const location = primaryResult?.geometry?.location || {};

        // Initialize empty variables for city, state, county, and country
        let city = "";
        let state = "";
        let county = "";
        let countries = "";
        let zip_code = "";

        // Parse the address components to extract city, state, county, and country
        addressComponents.forEach((component) => {
          if (component.types.includes("locality")) {
            city = component.long_name; // City
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name; // State
          } else if (component.types.includes("administrative_area_level_2")) {
            county = component.long_name; // County
          } else if (component.types.includes("country")) {
            countries = component.long_name; // Country
          }  else if (component.types.includes("postal_code")) {
            zip_code = component.long_name; // ZIP Code
          }
        });

        // Update your event data state with the extracted details
        setEventData({
          ...eventData,
          city,
          state,
          county,
          countries,
          zip_code,
          latitude: location?.lat || "",
          logitude: location?.lng || "",
        });
      } else {
        console.error("Geocoding API error:", response.data.status);
      }
    } catch (error) {
      console.error("Error fetching address from Geocoding API:", error);
    }
  };

  // Handle input change in the search bar
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    setEventData({ ...eventData, ["event_location"]: e.target.value });
    setEventError({ ...eventError, ["event_location"]: "" });
  };

  const handleSelect = (place) => {
    setSearchQuery(place);
    setEventData({ ...eventData, ["event_location"]: place });
    setSuggestions([]);
    setIsLoading(true);

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: place }, (results, status) => {
      if (status === "OK" && results[0]) {
        const { lat, lng } = results[0].geometry.location;
        setSelectedLocation({ lat: lat(), lng: lng() });
      }
      setIsLoading(false);
    });
  };

  // Handle search box suggestions
  const handleSearch = () => {
    const service = new window.google.maps.places.AutocompleteService();

    service.getPlacePredictions(
      { input: searchQuery },
      (predictions, status) => {
        if (status === "OK") {
          setSuggestions(predictions);
        }
      }
    );
  };
  return (
    <div>
      <div>
        <input
          type="text"
          className="form-control mt-3"
          placeholder="Search for a location"
          value={searchQuery}
          onChange={handleInputChange}
          onKeyUp={handleSearch}
        />
        {suggestions.length > 0 && !isLoading && (
          <ul>
            {suggestions.map((suggestion) => (
              <li
                key={suggestion.place_id}
                onClick={() => handleSelect(suggestion.description)}
              >
                <LocationSvg /> <span>{suggestion.description}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      <LoadScript
        googleMapsApiKey={GOOGLE_KEY}
        libraries={["places"]}
      ></LoadScript>
    </div>
  );
};

export default LocationSearch;
